export type TOrganizationFeatureFlags = {
  organizationFlags: Record<string, boolean>;
  defaultFlags: Record<string, boolean>;
};

type TOrganizationsListLike = {
  data?: Array<{ id: string; featureFlags?: Record<string, unknown> | null }>;
  featureFlags?: Record<string, unknown> | null;
};

const toBooleanRecord = (source: Record<string, unknown> | null | undefined): Record<string, boolean> =>
  Object.fromEntries(Object.entries(source ?? {}).map(([name, value]) => [name, value === true]));

export const pickOrganizationFeatureFlags = (
  response: TOrganizationsListLike | null | undefined,
  organizationId: string,
): TOrganizationFeatureFlags | null => {
  const organization = (response?.data ?? []).find((candidate) => candidate.id === organizationId);
  if (!organization) {
    return null;
  }
  return {
    organizationFlags: toBooleanRecord(organization.featureFlags),
    defaultFlags: toBooleanRecord(response?.featureFlags),
  };
};
